export const GOOGLE_ANALYTICS_GA4_ID = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS;
declare global {
  interface Window {
    gtag: any;
    ga: any;
    dataLayer: any;
  }
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
// log the pageview with their URL
export const pageview = (url: string) => {
  window.gtag('config', GOOGLE_ANALYTICS_GA4_ID, {
    page_path: url,
  });
};

// log specific events happening.
export const googleEvent = ({ action, params }: any) => {
  if (
    process.env.NODE_ENV === 'production' &&
    process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'
  ) {
    if (typeof window !== 'undefined') {
      window.dataLayer.push({ event: action, ...params });
    }
  }
};

// log specific events happening.
export const event = ({ action, params }: any) => {
  if (
    process.env.NODE_ENV === 'production' &&
    process.env.NEXT_PUBLIC_ENVIRONMENT === 'production'
  ) {
    if (typeof window !== 'undefined') {
      window.dataLayer.push({ event: action, params });
    }
  }
};
